var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "nav empty-list-message" },
    [
      _c("EmptyLLImg", { staticClass: "empty-list-message__img" }),
      _c("div", { staticClass: "empty-list-message__text" }, [
        _vm._v(" " + _vm._s(_vm.labelText) + " ")
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }